import { AlertOctagon, Wrench, FileSignature, Route } from "lucide-react";

/**
 * Compact "reports volume" badge for the Sites list row.
 * Shows per-report counts for the last 7 days — icons kept tiny + tone-coded so
 * the whole thing fits in a table cell without wrapping.
 *
 * When the site has zero activity we render a neutral dash so admins can still
 * eyeball "quiet vs busy" without extra clicks.
 */
export default function ReportVolumeBadge({ volumes, testId }) {
  const v = volumes || { incidents: 0, maintenance: 0, dar: 0, tours: 0 };
  const total = v.incidents + v.maintenance + v.dar + v.tours;
  if (!total) {
    return <span data-testid={testId} className="text-xs text-zinc-600 font-mono">—</span>;
  }
  // Each pill: icon + count. Muted when zero, tone-coloured when non-zero.
  const cells = [
    { key: "incidents",   n: v.incidents,   Icon: AlertOctagon,  tone: "#FF3B30", label: "Incidents" },
    { key: "maintenance", n: v.maintenance, Icon: Wrench,        tone: "#FF9F0A", label: "Maintenance" },
    { key: "dar",         n: v.dar,         Icon: FileSignature, tone: "#0A84FF", label: "DAR" },
    { key: "tours",       n: v.tours,       Icon: Route,         tone: "#22C55E", label: "Tour scans" },
  ];
  return (
    <div data-testid={testId} className="inline-flex items-center gap-1.5 font-mono text-xs">
      {cells.map(({ key, n, Icon, tone, label }) => (
        <span
          key={key}
          title={`${label}: ${n} in last 7 days`}
          className="inline-flex items-center gap-0.5"
          style={{ color: n > 0 ? tone : "#3F3F46" }}
        >
          <Icon className="size-3" />
          <span className={n > 0 ? "font-bold" : ""}>{n}</span>
        </span>
      ))}
    </div>
  );
}
